import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  standalone: true,
  imports: [MatIconModule, CommonModule],
})
export class ChipComponent {
  @Input() type: 'brand' | 'notification' | 'info' | 'trend' | 'green' | 'catalog' = 'brand';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() disabled: boolean = false;
  @Input() selected: boolean = false;
  @Input() icon: string = '';
  @Input() iconColor: string = '';
  @Input() closed: boolean = false;
  @Input() text: string = '';
  @Output() closeEmitEvent = new EventEmitter<void>();
  @Output() chipSelected = new EventEmitter<boolean>();

  emitCloseEvent(): void {
    this.closeEmitEvent.emit();
  }

  emitSelectionEvent(): void {
    if (!this.disabled) {
      this.chipSelected.emit(!this.selected);
    }
  }
}
